const learnings = {
  status: {
    accepted: "Learned",
    pending: "Suggestions",
    rejected: "Removed",
  },
  destination: {
    user: "Personal memory",
    workspace: "Workspace memory",
    organization: "Organization memory",
    mind: "Mind",
  },
  action: {
    memory: {
      create: "Remember",
      update: "Update memory",
      delete: "Forget memory",
      merge: "Merge memories",
    },
    mind: {
      create: "New block",
      update: "Update block",
      delete: "Remove block",
      merge: "Merge blocks",
    },
  },
  signal: {
    correction: "Correction",
    repeated_question: "Repeated question",
    decision: "Decision",
    preference: "Preference",
    unanswered: "Unanswered question",
    tool_error: "Tool error",
    duplicate: "Duplicate",
    contradiction: "Contradiction",
    unused: "Unused",
    external_agent: "External agent",
    inferred: "Noticed by the agent",
  },
  awaiting: {
    you: "Waiting for you",
    admins: "Waiting for an administrator",
  },
  why: "Why:",
  cause: "Likely cause:",
  fromYou: "From your conversations",
  fromConversation: "Suggested by the agent during a conversation",
  fromAgent: "Sent by {{client}}",
  externalAgent: "an external agent",
  referencesButton_one: "{{count}} message",
  referencesButton_other: "{{count}} messages",
  accept: "Apply",
  editAccept: "Edit and apply",
  reject: "Discard",
  remove: "Remove",
  loadError: "Could not load the proposals.",
  empty: {
    workspace:
      "Prodgy learns from use: it reviews this workspace's conversations and keeps here what it learned in the Brain. Remove anything that is not right.",
    personal:
      "Prodgy learns from use: what it learned about you, or from your conversations, shows up here. Remove anything that is not right.",
  },
  emptyStatus: {
    pending: "No suggestions for the Mind.",
    rejected: "Nothing removed.",
  },
  edit: {
    title: "Edit and apply",
    description: "Adjust the text before applying it to the Mind.",
    cancel: "Cancel",
    confirm: "Apply",
  },
  toast: {
    accepted: "Applied to the Mind.",
    rejected: "Discarded. It will not be suggested again.",
    removed: "Removed. Prodgy will not learn it again.",
    error: "Could not complete this action.",
  },
  references: {
    title: "Where it came from",
    description: "The messages behind this proposal. You only see the text of your own conversations.",
    hidden: "Message from another person's conversation",
    empty: "This proposal does not point to messages.",
    loadError: "Could not load the messages.",
  },
  review: {
    now: "Review now",
    done: "Review finished: {{messages}} messages read, {{proposals}} new proposals.",
    error: "Could not run the review.",
  },
  settings: {
    open: "Learnings settings",
    title: "Learnings settings",
    description: "How Prodgy reviews conversations to learn.",
    enabled: "Review conversations",
    frequency: "How often",
    daily: "Daily",
    weekly: "Weekly",
    lastRun: "Last review: {{date}}",
    neverRan: "No review yet.",
    lastError: "Last review failed: {{error}}",
    saveError: "Could not save the settings.",
  },
  optOut: {
    label: "Do not review my conversations",
    hint: "Prodgy stops reading your conversations to propose improvements to the Brain of this organization.",
    saveError: "Could not save this preference.",
  },
} as const;

export default learnings;
